module.exports = __webpack_public_path__ + "img/Worker System.a69d83de.svg";